import React from "react"
import { StaticQuery, graphql } from 'gatsby'
import PropTypes from "prop-types"

import Link from "../utils/link"

import logoDark from "../assets/images/logo_dark.svg"
import logoLight from "../assets/images/logo_light.svg"

import "./header.scss"

const Header = (props) => (
  <StaticQuery
    query={graphql`
      query mediaQuery {
        allWpRoom(sort: {fields: menuOrder}) {
          edges {
            node {
              title
              slug
            }
          }
        }
        wp {
          siteSettings {
            acf {
              social {
                facebook
                instagram
              }
              phone {
                text
                link
              }
            }
          }
        }
      }
    `}
    render={(data) => {
      const [isVisible, setIsVisible] = React.useState(false)
      const [isRoomVisible, setIsRoomVisible] = React.useState(false)
      const [darkHeader, setDarkHeader] = React.useState(false);

      const toggleIsVisible = (e) => {
        e.preventDefault()
        setIsVisible(!isVisible)
      }

      const toggleRoomList = () => {
        setIsRoomVisible(!isRoomVisible)
      }

      React.useEffect(() => {
        const handleScroll = () => {
          const currentScrollY = window.scrollY;
          if (!document.querySelector('.image-section__first-cards')) return false
          if (currentScrollY > document.querySelector('.image-section__first-cards').offsetTop) {
            setDarkHeader(true);
          }
          if (currentScrollY < document.querySelector('.image-section__first-cards').offsetTop) {
            setDarkHeader(false);
          }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => window.removeEventListener("scroll", handleScroll);
      }, [darkHeader]);

      return (
         <>
          <header className={`header ${darkHeader ? 'header--dark' : ''}`}>
            <button
              onClick={toggleIsVisible}
              className={`
                header__hamburger ${isVisible ? "active" : ""} ${
                props.isLight ? "is-light" : ""
              }
              `}
            >
              {isVisible ? (
                <span>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="times"
                    className="svg-inline--fa fa-times fa-w-11"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 352 512"
                  >
                    <path
                      fill="currentColor"
                      d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                    />
                  </svg>
                </span>
              ) : (
                <span>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="bars"
                    className="svg-inline--fa fa-bars fa-w-14"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                  >
                    <path
                      fill="currentColor"
                      d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
                    />
                  </svg>
                </span>
              )}
            </button>
            <div className="header__container">
              <nav
                className={`header__container__start ${props.isLight ? "is-light" : ""} ${
                  isVisible ? "active" : ""
                }`}
              >
                <div className="header__container__start__link">
                  <Link to="/">Home</Link>
                </div>
                <div className="header__container__start__link">
                  <span onClick={(e) => toggleRoomList(e)}>
                    Units
                  </span>
                  {isRoomVisible && (
                    <>
                      <div className={`${props.page}`}>
                        { data.allWpRoom.edges && data.allWpRoom.edges.map((item, index) => {
                          return (
                            <div key={index}>
                              <Link to={`/room/${item.node.slug}`} onClick={toggleRoomList}>
                                {item.node.title}
                              </Link>
                            </div>
                          )
                        })}
                      </div>
                    </>
                  )}
                </div>
                <div className="header__container__start__link">
                  <Link to="/location">Location</Link>
                </div>
                <div className="header__container__start__link">
                  <Link to="/activities">Explore</Link>
                </div>
                <div className="header__container__start__link">
                  <Link to="/gallery">Gallery</Link>
                </div>
                <div className="header__container__start__link">
                  <Link to="/contact">Contact</Link>
                </div>
              </nav>
              <nav className="header__container__brand">
                <Link to="/" title="Site Name">
                  {props.isLight ? (
                    <img src={logoLight} alt="Kooyong Apartments" />
                  ) : (
                    <img src={logoDark} alt="Kooyong Apartments" />
                  )}
                </Link>
              </nav>
              <nav
                className={`header__container__end ${props.isLight ? "is-light" : ""} ${
                  isVisible ? "active" : ""
                }`}
              >
                <div className="header__container__end__contact">
                  <Link to={data.wp.siteSettings.acf.phone.link}>{data.wp.siteSettings.acf.phone.text}</Link>
                </div>
                <div className="header__container__end__social">
                  { data.wp.siteSettings.acf.social.instagram &&
                    <Link to={data.wp.siteSettings.acf.social.instagram}>
                      <i className="fab fa-instagram" />
                    </Link>
                  }
                  { data.wp.siteSettings.acf.social.facebook &&
                    <Link to={data.wp.siteSettings.acf.social.facebook}>
                      <i className="fab fa-facebook-f" />
                    </Link>
                  }
                </div>
              </nav>
            </div>
          </header>
        </>
      )
    }}
  />
)

Header.propTypes = {
  isLight: PropTypes.bool,
  page: PropTypes.string,
}

Header.defaultProps = {
  isLight: false,
}

export default Header
